export const stepperStepTestId = (parentTestId, stepId)=>parentTestId ? "".concat(parentTestId, "-step-").concat(stepId) : "step-".concat(stepId);
